
<!--start header-->

<header class="head d-flex justify-content-center align-items-center">

    <div class="head-caption text-center">
     <h1>BLOG PAGE</h1>
     <p>Tomato is a delicious restaurant website template</p>
    </div>
  
  </header>
  
  <!--end header-->


  <!--start section blog-->

  <section class="container py-5 blog">
      <div class="row">


        <div class="col-lg-4 col-md-6  mb-3">
            <div class="position-relative">
                <img src="assets/images/22.jpg" class="img-fluid" alt="">
                <div class="pt-3 blog-content">
                    <h3 class="pb-1">Blog Heading Here</h3>
                    <p class="pb-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                         Lorem Ipsum has been the industry's standard dummy text ever since.
                    </p>
                    <button class="btn-default border-0 text-dark">READ MORE</button>
                    <div class="blog-icon d-flex justify-content-center align-items-center mt-3">
                        <i class="fas fa-image"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6  mb-3 blog-media2">
            <div class="position-relative">
                <img src="assets/images/23.jpg" class="img-fluid" alt="">
                <div class="pt-3 blog-content">
                    <h3 class="pb-1">Blog Heading Here</h3>
                    <p class="pb-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                         Lorem Ipsum has been the industry's standard dummy text ever 
                         since the 1500s, when an unknown printer.
                    </p>
                    <button class="btn-default border-0 text-dark">READ MORE</button>
                    <div class="blog-icon d-flex justify-content-center align-items-center mt-3">
                        <i class="fas fa-image"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6  mb-3 blog-media">
            <div class="position-relative">
                <div class="text-white blog-caption d-flex justify-content-center align-items-center text-center">
                    <div>
                       <h1>Sorry</h1>
                       <p>This video does not exist.</p>
                    </div>
                </div>
                <div class="pt-3 blog-content">
                    <h3 class="pb-1">Blog Heading Here</h3>
                    <p class="pb-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                         Lorem Ipsum has been the industry's standard dummy text ever 
                         since the 1500s, when an unknown printer took a galley of type and
                          scrambled it to make a type specimen book.
                           It has survived not only five centuries.
                    </p>
                    <button class="btn-default border-0 text-dark">READ MORE</button>
                    <div class="blog-icon d-flex justify-content-center align-items-center mt-3">
                        <i class="fab fa-youtube"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 mb-3">
            <div class="position-relative  position-blogs">
                <img src="assets/images/23.jpg" class="img-fluid" alt="">
                <div class="pt-3 blog-content">
                    <h3 class="pb-1">Blog Heading Here</h3>
                    <p class="pb-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                         Lorem Ipsum has been the industry's standard dummy text ever 
                         since the 1500s, when an unknown printer.
                    </p>
                    <button class="btn-default border-0 text-dark">READ MORE</button>
                    <div class="blog-icon d-flex justify-content-center align-items-center mt-3">
                        <i class="fas fa-image"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6  mb-3">
            <div class="position-relative  position-blog">
                <img src="assets/images/22.jpg" class="img-fluid" alt="">
                <div class="pt-3 blog-content">
                    <h3 class="pb-1">Blog Heading Here</h3>
                    <p class="pb-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                         Lorem Ipsum has been the industry's standard dummy text ever 
                         since the 1500s, when an unknown printer.
                    </p>
                    <button class="btn-default border-0 text-dark">READ MORE</button>
                    <div class="blog-icon d-flex justify-content-center align-items-center mt-3">
                        <i class="fas fa-image"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-lg-4 col-md-6  mb-3">
            <div class="position-relative">
                <img src="assets/images/23.jpg" class="img-fluid" alt="">
                <div class="pt-3 blog-content">
                    <h3 class="pb-1">Blog Heading Here</h3>
                    <p class="pb-3">Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                         Lorem Ipsum has been the industry's standard dummy text ever 
                         since the 1500s, when an unknown printer.
                    </p>
                    <button class="btn-default border-0 text-dark">READ MORE</button>
                    <div class="blog-icon d-flex justify-content-center align-items-center mt-3">
                        <i class="fas fa-image"></i>
                    </div>
                </div>
            </div>
        </div>

        


      </div>
  </section>
 <!--end section blog-->


 <!--start section insta-->

<section class="bg">

    <div class="container py-4">
  
     <div class="row insta-caption">
        <div class="col-md-3 sub-caption">
            <p>SUBSCRIBE</p>
        </div>
        <div class="col-md-8">
         <p class="text-muted p">Get updates about new dishes and upcoming events</p>
     </div>
       
       </div>
       <div class="registers d-flex justify-content-end pb-4">
         <input class="inpt-caption mr-4" type="email" placeholder=" Your Email Address ">
         <button type="submit" class="register"><i class="fas fa-chevron-right fa-1x"></i></button>
       </div>
  
    </div>
  </section>
  
  <!--end section insta-->